import { HimmaContext } from '../context/HimmaContext';
import { useState, useCallback, useContext } from 'react';

export const useJoinUsApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Get all join us entries
  const getAllJoinUs = useCallback(
    async (params: {
      page: number;
      limit: number;
      search?: string;
      type?: 'Rider' | 'Partner';
      sortBy?: 'name' | 'email' | 'phone' | 'type' | 'createdAt';
      sortOrder?: 'asc' | 'desc';
    }) => {
      setLoading(true);
      setError(null);
      try {
        // The client SDK must be generated and injected via HimmaContext.
        // Do not use mock data — throw an explicit error if SDK method is missing.
        if (!api || typeof (api as any).getAllJoinUs !== 'function') {
          const message =
            'Client SDK method getAllJoinUs not available. Run `npm run generate:client:sdk` and ensure HimmaContext provides DefaultApi.';
          setError(message);
          throw new Error(message);
        }

        // The SDK method signature is positional: (page, limit, sortBy, sortOrder, search?, type?)
        const response = await (api as any).getAllJoinUs(
          params.page,
          params.limit,
          params.sortBy || 'createdAt',
          params.sortOrder || 'desc',
          params.search,
          params.type
        );

        // `response` is an AxiosResponse whose `data` matches the generated schema:
        // { data: Array<...>, pagination: {...} }
        // The UI expects `{ data: { joinUsEntries: [...], pagination: {...} } }` (legacy mock shape),
        // so transform accordingly.
        const payload = (response && (response as any).data) ? (response as any).data : response;
        return {
          data: {
            joinUsEntries: payload?.data || [],
            pagination: payload?.pagination || {},
          },
        };
      } catch (err: any) {
        const errorMessage =
          err.response?.data?.message ||
          err.message ||
          'An error occurred while fetching join us entries';
        setError(errorMessage);
        throw new Error(errorMessage);
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return {
    getAllJoinUs,
    loading,
    error,
  };
};